// Vault Downloads System - Token-based integration with Cloud Run services

function copyBandcampCode(code) {
    const text = String(code).toUpperCase();
    try {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text).then(() => true).catch(() => false);
        }
    } catch (e) {}
    try {
        const input = document.createElement('input');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.top = '0';
        input.style.left = '-9999px';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.focus({ preventScroll: true });
        input.select();
        input.setSelectionRange(0, input.value.length);
        const ok = document.execCommand('copy');
        document.body.removeChild(input);
        if (ok) return true;
    } catch (e) {}
    try {
        const span = document.createElement('span');
        span.textContent = text;
        span.style.position = 'fixed';
        span.style.left = '-9999px';
        span.style.userSelect = 'all';
        span.style.webkitUserSelect = 'all';
        document.body.appendChild(span);
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(span);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        selection.removeAllRanges();
        document.body.removeChild(span);
        return true;
    } catch (e) {}
    try {
        window.prompt('Copy this code', text);
    } catch (e) {}
    return false;
}

function handleBandcampCodeClick(el, code) {
    try {
        copyBandcampCode(code);
    } catch (e) {
    }

    el.classList.add('copied');
    if (el._copiedTimer) {
        clearTimeout(el._copiedTimer);
    }
    el._copiedTimer = setTimeout(() => {
        el.classList.remove('copied');
        el._copiedTimer = null;
    }, 1200);

    const card = el.closest('.rj-album');
    if (card) {
        const redeemBtn = card.querySelector('.rj-bandcamp-redeem-button');
        if (redeemBtn) {
            redeemBtn.classList.add('nudge');
            if (redeemBtn._nudgeTimer) clearTimeout(redeemBtn._nudgeTimer);
            redeemBtn._nudgeTimer = setTimeout(() => {
                redeemBtn.classList.remove('nudge');
                redeemBtn._nudgeTimer = null;
            }, 1200);
        }
    }
}


class VaultTokenDownloadManager {
    constructor() {
        this.token = null;
        this.email = null;
        this.tokenData = null;
        this.albumImages = {
            "RJCD1": "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD1_600.webp",
            "RJCD2": "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD2_600.webp",
            "RJCD3": "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD3_600.webp",
            "RJCD4": "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD4_600.webp",
            "RJ4A": "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD4A_600.webp",
            "RJCD5": "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJCD5_600.webp",
            "RJ-5A": "https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJ5A_600.webp"
        };
        this.albumColors = {
            "Ronald Jenkees": {
                primaryColor: "#2c1810",
                secondaryColor: "#b69b8c", 
                textColor: "#ffffff",
                accentColor: "#ffd700",
                year: "2007"
            },
            "Disorganized Fun": {
                primaryColor: "#4a2c2e",
                secondaryColor: "#c17f83",
                textColor: "#ffffff", 
                accentColor: "#ffd700",
                year: "2009"
            },
            "Days Away": {
                primaryColor: "#1a1e3c",
                secondaryColor: "#8494cf",
                textColor: "#ffffff",
                accentColor: "#ffd700", 
                year: "2012"
            },
            "Alpha Numeric": {
                primaryColor: "#e6c405",
                secondaryColor: "#8494b7",
                textColor: "#2c2c2c",
                accentColor: "#ffffff",
                year: "2014"
            },
            "Make It Fun V1": {
                primaryColor: "#181713", 
                secondaryColor: "#d6b214",
                textColor: "#f1f9ec",
                accentColor: "#a9b2ff",
                year: "2016"
            },
            "Rhodes Deep": {
                primaryColor: "#2a1b35",
                secondaryColor: "#ff8e3c", 
                textColor: "#ff9ec7",
                accentColor: "#ffd700",
                year: "2017"
            },
            "Wonder And Flow": {
                primaryColor: "#a7a8a2",
                secondaryColor: "#faf9f5",
                textColor: "#698695",
                accentColor: "#e1d8ce",
                year: "2024"
            }
        };
        this.albumGradients = {
            "RJCD1": ["#3f241a", "#94836c"],
            "RJCD2": ["#c17f83", "#5e95cb"],
            "RJCD3": ["#8494cf", "#2aa1c0"],
            "RJCD4": ["#e6c405", "#8494b7"],
            "RJ4A": ["#d6b214", "#a9b2ff"],
            "RJCD5": ["#ff8e3c", "#5e95cb"],
            "RJ-5A": ["#a7a8a2", "#698695"]
        };
        this.downloadLimits = {
            mp3: 3,
            flac: 3,
            wav: 3,
            bandcamp: 0
        };
        // First-time download popup state
        this.firstDownloadShown = false; // legacy; not used to gate popup anymore
        this.pendingDownload = null;
        this.hasCompletedAnyDownload = false;

        this.initialize();
    }

    initialize() {
        this.extractURLParameters();
        this.loadDownloadCompletionFlag();
        this.loadingStartTime = Date.now();
        // Bind first-download confirmation modal buttons (if present in DOM)
        this.ensureFirstDownloadModalBindings();

        if (this.token) {
            // Token flow: show JS loading then render token UI
            this.showLoadingState();
            this.initializeTokenDownloadSystem();
        } else {
            // Regular vault: keep server-rendered single placeholder and render immediately
            this.renderRegularVaultInterface();
        }
    }

    extractURLParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get('token');
        const urlEmail = urlParams.get('email');
        
        // Check for token in URL first, then fallback to sessionStorage
        if (urlToken) {
            this.token = urlToken;
            this.email = urlEmail;
            
            // Store in sessionStorage for security
            try {
                sessionStorage.setItem('rj_vault_token', urlToken);
                if (urlEmail) {
                    sessionStorage.setItem('rj_vault_email', urlEmail);
                }
                
                // Clear URL silently after 5 minutes to allow bookmarking
                setTimeout(() => this.clearTokenFromURL(), 300000); // 5 minutes = 300,000ms
                
            } catch (e) {
                console.warn('SessionStorage not available, token will remain in URL');
            }
        } else {
            // Try to get token from sessionStorage
            try {
                this.token = sessionStorage.getItem('rj_vault_token');
                this.email = sessionStorage.getItem('rj_vault_email');
            } catch (e) {
                // SessionStorage not available, token stays null
            }
        }
    }
    
    clearTokenFromURL() {
        // Remove token and email parameters from URL without page reload
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        
        const hasToken = params.has('token');
        const hasEmail = params.has('email');
        
        if (hasToken || hasEmail) {
            params.delete('token');
            params.delete('email');
            
            // Update URL without page reload
            const newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '');
            
            try {
                window.history.replaceState({}, '', newUrl);
                console.log('Token safely moved from URL to sessionStorage');
            } catch (e) {
                console.warn('Could not clean URL - token remains visible');
            }
        }
    }


    clearContainer() {
        const container = document.getElementById('rj-albumContainer');
        if (container) {
            // Only clear if there's no loading state already
            const hasLoading = container.querySelector('.rj-loading');
            if (!hasLoading) {
                container.innerHTML = '';
            }
        }
    }

    showLoadingState() {
        const container = document.getElementById('rj-albumContainer');
        if (container) {
            // If server rendered a single placeholder frame, keep it
            if (container.querySelector('.rj-placeholder')) {
                container.setAttribute('aria-busy', 'true');
                console.log('Using server placeholder for loading.');
                return;
            }

            container.setAttribute('aria-busy', 'true');
            // Fallback JS loading if no server placeholder present
            container.innerHTML = `
                <div class="rj-loading" style="padding: 2rem; text-align: center; min-height: 200px;">
                    <div class="rj-loading-skeleton">
                        <div class="rj-skeleton-item"></div>
                        <div class="rj-skeleton-item"></div>
                        <div class="rj-skeleton-item"></div>
                        <div class="rj-skeleton-item"></div>
                        <div class="rj-skeleton-item"></div>
                        <div class="rj-skeleton-item"></div>
                    </div>
                    <div class="rj-loading-message" style="margin-top: 2rem;">
                        <span class="rj-loading-text" style="
                            color: rgba(255, 255, 255, 0.9); 
                            font-size: 1.8rem; 
                            font-weight: 600; 
                            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); 
                            animation: rj-loading-pulse 1.5s ease-in-out infinite;
                        ">Loading Jams...</span>
                    </div>
                    <span class="sr-only">Loading your albums…</span>
                </div>
            `;
            
            console.log('Loading state displayed at:', Date.now());
        }
    }

    async initializeTokenDownloadSystem() {
        try {
            const tokenData = await this.fetchTokenData();
            this.tokenData = tokenData;
            this.ensureFreshTokenResetsFlag();
            this.renderTokenDownloadInterface();
        } catch (error) {
            console.error('Token system initialization failed:', error);
            this.handleTokenError(error);
        }
    }

    initializeRegularVaultSystem() {
        // Render immediately for regular vault; keep server placeholder until content swaps
        this.renderRegularVaultInterface();
    }

    async fetchTokenData() {
        const endpoints = [
            `https://token-download-service-688914303528.us-central1.run.app/token-info?token=${this.token}`,
            `https://token-download-public-688914303528.us-central1.run.app/token-info?token=${this.token}`
        ];

        for (const endpoint of endpoints) {
            try {
                const response = await fetch(endpoint);
                if (response.ok) {
                    return await response.json();
                }
            } catch (error) {
                // Try next endpoint
            }
        }

        throw new Error('Unable to fetch token data from any endpoint');
    }

    renderTokenDownloadInterface() {
        const container = document.getElementById('rj-albumContainer');
        if (!container) {
            console.error('Album container not found');
            return;
        }

        // Ensure loading message shows for at least 3 seconds to give user time to see it
        const minLoadingTime = 3000; // 3 seconds
        const elapsedTime = Date.now() - (this.loadingStartTime || 0);
        const remainingTime = Math.max(0, minLoadingTime - elapsedTime);

        console.log('Token render timing:', {
            elapsed: elapsedTime,
            remaining: remainingTime,
            willWait: remainingTime > 0
        });

        setTimeout(() => {
            try { const pre = document.getElementById('rj-vault-preloader'); if (pre) { pre.style.opacity = '0'; setTimeout(() => { if (pre && pre.parentNode) pre.parentNode.removeChild(pre); }, 300); } } catch(e) {}
            console.log('Rendering token interface after loading delay');
            container.innerHTML = '';
            container.setAttribute('aria-busy', 'false');
            
            if (!this.tokenData || !this.tokenData.albums) {
                this.handleTokenError(new Error('No album data found in token response'));
                return;
            }

            this.enableBandcampTab();
            this.hideCheckoutSection();
            this.updateCustomerGreeting();
            this.generateDownloadAlbumCards();
            this.initializeDownloadEventListeners();
            
            setTimeout(() => {
                const container = document.querySelector('.rj-vault-wrapper .rj-album-container');
                if (container) {
                    container.classList.add('rj-vault-ready');
                }
            }, 100);
        }, remainingTime);
    }

    renderRegularVaultInterface() {
        if (typeof rjLoadDownloadss === 'function') {
            try { const pre = document.getElementById('rj-vault-preloader'); if (pre) { pre.style.opacity = '0'; setTimeout(() => { if (pre && pre.parentNode) pre.parentNode.removeChild(pre); }, 300); } } catch(e) {}
            rjLoadDownloadss();
        }
    }

    enableBandcampTab() {
        const bandcampTab = document.querySelector('.rj-format-tab[data-format="bandcamp"]');
        if (bandcampTab) {
            bandcampTab.removeAttribute('disabled');
            bandcampTab.removeAttribute('aria-disabled');
        }
    }

    updateCustomerGreeting() {
        if (this.tokenData) {
            const customerName = this.tokenData.customerFirstName ||
                                this.tokenData.customerName ||
                                this.tokenData.firstName ||
                                this.tokenData.name ||
                                (this.tokenData.customerInfo && this.tokenData.customerInfo.firstName);
            
            const firstNameElement = document.querySelector('.rj-first-name');
            const greetingElement = document.querySelector('.rj-greeting');
            
            if (customerName) {
                if (firstNameElement) {
                    firstNameElement.textContent = customerName;
                }
                if (greetingElement) {
                    greetingElement.textContent = `Hello ${customerName}!`;
                }
                
                window.tokenInfo = window.tokenInfo || {};
                window.tokenInfo.customerInfo = window.tokenInfo.customerInfo || {};
                window.tokenInfo.customerInfo.firstName = customerName;
                
                const event = new CustomEvent('tokenDataLoaded', {
                    detail: { firstName: customerName }
                });
                document.dispatchEvent(event);
                window.dispatchEvent(event);
            } else {
                // No customer name found - set greeting to "Hello there!"
                if (greetingElement) {
                    greetingElement.textContent = 'Hello there!';
                }
            }
        }
    }

    // Persisted "has completed any download" state handling
    getDownloadFlagStorageKey() {
        if (this.token) {
            return `rj_vault_any_downloaded:${this.token}`;
        }
        return null;
    }

    loadDownloadCompletionFlag() {
        try {
            const key = this.getDownloadFlagStorageKey();
            if (!key) return;
            const val = localStorage.getItem(key);
            if (val === '1') {
                this.hasCompletedAnyDownload = true;
            }
        } catch (e) {
            // ignore storage issues
        }
    }

    saveDownloadCompletionFlag() {
        try {
            const key = this.getDownloadFlagStorageKey();
            if (!key) return;
            localStorage.setItem(key, '1');
        } catch (e) {
            // ignore storage issues
        }
    }

    removeDownloadCompletionFlag() {
        try {
            const key = this.getDownloadFlagStorageKey();
            if (!key) return;
            localStorage.removeItem(key);
        } catch (e) {
            // ignore storage issues
        }
    }

    // Ensure popup shows for a completely fresh token (no prior usage)
    ensureFreshTokenResetsFlag() {
        if (!this.tokenData || !this.tokenData.albums) return;
        const limits = this.downloadLimits || {};
        let allFresh = true;

        for (const albumInfo of Object.values(this.tokenData.albums)) {
            const dls = albumInfo.downloads || {};
            for (const fmt of Object.keys(limits)) {
                if (fmt === 'bandcamp') continue; // bandcamp not gated
                const total = limits[fmt];
                const remaining = dls[fmt];
                if (typeof total === 'number') {
                    if (typeof remaining !== 'number' || remaining !== total) {
                        allFresh = false;
                        break;
                    }
                }
            }
            if (!allFresh) break;
        }

        if (allFresh) {
            this.hasCompletedAnyDownload = false;
            this.removeDownloadCompletionFlag();
        }
    }

    // If token data shows prior usage (remaining < limit), never show the popup
    checkPriorDownloadUsage() {
        if (!this.tokenData || !this.tokenData.albums) return;
        const limits = this.downloadLimits || {};
        for (const albumInfo of Object.values(this.tokenData.albums)) {
            const dls = albumInfo.downloads || {};
            for (const [fmt, remaining] of Object.entries(dls)) {
                const total = limits[fmt];
                if (typeof total === 'number' && typeof remaining === 'number') {
                    if ((total - remaining) > 0) {
                        this.hasCompletedAnyDownload = true;
                        this.saveDownloadCompletionFlag();
                        return;
                    }
                }
            }
        }
    }

    generateDownloadAlbumCards() {
        const container = document.getElementById('rj-albumContainer');
        if (!container || !this.tokenData.albums) {
            return;
        }

        const albumsData = this.tokenData.albums;
        const orderNewestFirst = ['RJ-5A', 'RJCD5', 'RJ4A', 'RJCD4', 'RJCD3', 'RJCD2', 'RJCD1'];
        const getIndex = (id) => {
            const idx = orderNewestFirst.indexOf(id);
            return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
        };
        const sortedAlbumEntries = Object.entries(albumsData).sort(([albumIdA], [albumIdB]) => {
            return getIndex(albumIdA) - getIndex(albumIdB);
        });
        
        sortedAlbumEntries.forEach(([albumId, albumInfo]) => {
            const albumCard = this.createDownloadAlbumCard(albumId, albumInfo);
            container.appendChild(albumCard);
        });
        
        if (sortedAlbumEntries.length === 1) {
            container.classList.add('rj-single-album');
        } else {
            container.classList.remove('rj-single-album');
        }
    }

    createDownloadAlbumCard(albumId, albumInfo) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('rj-album-wrapper');

        const albumDiv = document.createElement('div'); 
        albumDiv.classList.add('rj-album', 'rj-crunchy-album', 'rj-card-style');
        albumDiv.setAttribute('data-album-id', albumId);

        const activeTab = document.querySelector('.rj-format-tab.active');
        const selectedFormat = activeTab ? activeTab.dataset.format : 'mp3';
        
        // Process font color from API or use default
        let fontColor = '#ffffff';
        if (albumInfo.styles && albumInfo.styles['Font colors']) {
            const rawFontColor = albumInfo.styles['Font colors'];
            fontColor = rawFontColor.startsWith('#') ? rawFontColor : `#${rawFontColor}`;
        }
        
        const downloadButtonHtml = this.generateSingleDownloadButton(albumId, albumInfo, selectedFormat, fontColor);
        const downloads = albumInfo.downloads[selectedFormat] || 0;
        const progressDotsHtml = this.generateProgressDots(downloads, this.downloadLimits[selectedFormat], selectedFormat);
        
        // Determine album cover image
        // Prefer art provided by token/meta first; fall back to hardcoded map
        let coverUrl = null;

        const isValidValue = (value) => value != null && value !== '' && value !== 'undefined';
        const imageProperties = ['art', 'cover', 'image', 'coverUrl', 'artwork', 'thumb', 'thumbnail'];

        for (const prop of imageProperties) {
            if (albumInfo[prop] && isValidValue(albumInfo[prop])) {
                coverUrl = albumInfo[prop];
                break;
            }
        }

        if (!coverUrl) {
            coverUrl = this.albumImages[albumId];
        }

        const albumName = albumInfo.name || albumInfo.title || albumId;
        const imageSrc = coverUrl || `https://via.placeholder.com/300x300/2c1810/ffffff?text=${encodeURIComponent(albumName)}`;
        const subtitle = this.getAlbumSubtitle(albumId, albumName);

        // Apply album-specific gradient colors
        let gradientColors;

        // Try API gradients first
        if (albumInfo.styles) {
            const gradient1 = albumInfo.styles.gradient1 || albumInfo.styles.Gradient1 || 
                              albumInfo.styles['Gradient 1'] || albumInfo.styles['gradient 1'] || null;
            const gradient2 = albumInfo.styles.gradient2 || albumInfo.styles.Gradient2 || 
                              albumInfo.styles['Gradient 2'] || albumInfo.styles['gradient 2'] || null;
            
            if (gradient1 && gradient2) {
                gradientColors = [gradient1, gradient2];
            }
        }

        // Fallback to hardcoded gradients
        if (!gradientColors) {
            gradientColors = this.albumGradients[albumId] || this.albumGradients["RJCD1"];
        }

        const color1 = gradientColors[0].startsWith('#') ? gradientColors[0] : `#${gradientColors[0]}`;
        const color2 = gradientColors[1].startsWith('#') ? gradientColors[1] : `#${gradientColors[1]}`;
        const gradientStyle = `background: linear-gradient(90deg, ${color1} 0%, ${color2} 100%) !important;`;

        albumDiv.innerHTML = `
            <div class="rj-card-cover">
                <img src="${imageSrc}" alt="${albumName}" onError="this.onerror=null; this.src='https://via.placeholder.com/300x300/666/fff?text=${encodeURIComponent(albumName)}';">
            </div>
            <div class="rj-card-download-section" style="${gradientStyle}">
                <div class="rj-download-button-container">
                    ${downloadButtonHtml}
                </div>
                <div class="rj-progress-dots-container">
                    ${progressDotsHtml}
                </div>
            </div>
        `;

        wrapper.appendChild(albumDiv);
        return wrapper;
    }

    generateSingleDownloadButton(albumId, albumInfo, format, fontColor = '#ffffff') {
        // Handle Bandcamp format differently
        if (format === 'bandcamp') {
            return this.generateBandcampContent(albumId, albumInfo, fontColor);
        }

        const downloads = albumInfo.downloads[format] || 0;
        const isExhausted = downloads === 0;
        const canRecharge = !albumInfo.rechargeUsed && isExhausted;

        return `
            <span 
                class="rj-download-text ${isExhausted ? 'exhausted' : 'available'}"
                data-album-id="${albumId}"
                data-format="${format}"
                data-recharge="${canRecharge}"
                style="cursor: ${isExhausted && !canRecharge ? 'default' : 'pointer'}; color: ${fontColor} !important;"
            >
                ${isExhausted ? (canRecharge ? 'REFRESH DOWNLOADS' : 'NO DOWNLOADS LEFT') : `DOWNLOAD ${format.toUpperCase()}`}
            </span>
        `;
    }

    generateBandcampContent(albumId, albumInfo, fontColor = '#ffffff') {
        // Get Bandcamp codes from the downloadCodeMapping in token data
        const bandcampCodes = this.getBandcampCodes(albumId);
        
        if (bandcampCodes && bandcampCodes.length > 0) {
            const codesHTML = bandcampCodes.map(code => `
                <div class="rj-bandcamp-code-item" role="button" tabindex="0" data-code="${code.toUpperCase()}" style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(${fontColor === '#ffffff' ? '255,255,255' : '0,0,0'}, 0.1);
                    color: ${fontColor};
                    font-family: monospace;
                    font-size: 1.4rem;
                    font-weight: 600;
                    letter-spacing: 1px;
                    padding: 14px 20px;
                    margin: 8px 0;
                    border-radius: 8px;
                    min-width: 180px;
                    box-sizing: border-box;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    position: relative;
                ">
                    <span class="code-text" style="display: block;">${code.toUpperCase()}</span>
                    <span class="copy-status" style="display: none; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 1.6rem; font-weight: 600; white-space: nowrap;">✓ Copied</span>
                </div>
            `).join('');
            
            setTimeout(() => {
                document.querySelectorAll('.rj-bandcamp-code-item[data-code]').forEach(item => {
                    const code = item.dataset.code;
                    
                    item.removeEventListener('click', item._clickHandler);
                    item.removeEventListener('keydown', item._keydownHandler);
                    
                    item._clickHandler = function() {
                        handleBandcampCodeClick(this, code);
                    };
                    
                    item._keydownHandler = function(event) {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            handleBandcampCodeClick(this, code);
                        }
                    };
                    
                    item.addEventListener('click', item._clickHandler);
                    item.addEventListener('keydown', item._keydownHandler);

                });
            }, 0);

            return `
                <style>
                .rj-bandcamp-code-item.copied .code-text { display: none !important; }
                .rj-bandcamp-code-item.copied .copy-status { display: block !important; }
                .rj-bandcamp-code-item.copied { border: none !important; outline: none !important; box-shadow: none !important; }
                .rj-bandcamp-code-item:focus { outline: none !important; box-shadow: none !important; }
            </style>
                <div class="rj-bandcamp-codes">
                    <div class="rj-bandcamp-codes-container">
                        ${codesHTML}
                    </div>
                </div>
            `;
        } else {
            return `
                <div class="rj-bandcamp-codes">
                    <div class="rj-bandcamp-codes-label" style="color: ${fontColor}; opacity: 0.8; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 0.3rem;">
                        Bandcamp Code
                    </div>
                    <div class="rj-bandcamp-codes-value" style="color: ${fontColor}; font-size: 1.1rem; font-weight: 600;">
                        Available after purchase
                    </div>
                </div>
            `;
        }
    }

    getBandcampCodes(albumId) {
        if (!this.tokenData) {
            return null;
        }

        // Build candidate keys to be resilient to hyphen differences (e.g., RJ4A vs RJ-4A)
        const candidates = [];
        const add = (v) => { if (v && !candidates.includes(v)) candidates.push(v); };

        add(albumId);

        // Add de-hyphenated variant
        if (albumId.includes('-')) {
            add(albumId.replace(/-/g, ''));
        } else {
            // For patterns like RJ4A, RJ5A -> add RJ-4A, RJ-5A
            const m = albumId.match(/^RJ(\d)A$/i);
            if (m) add(`RJ-${m[1]}A`);
        }

        // Also try uppercase variants just in case
        const base = albumId.toUpperCase();
        add(base);
        add(base.replace(/-/g, ''));
        const m2 = base.match(/^RJ(\d)A$/i);
        if (m2) add(`RJ-${m2[1]}A`);

        // Check for alternative code properties in token data
        const possibleCodeProperties = ['bandcampCodes', 'codes', 'downloadCodes', 'bandcamp', 'redemptionCodes'];
        for (const prop of possibleCodeProperties) {
            const bag = this.tokenData[prop];
            if (bag) {
                for (const key of candidates) {
                    if (bag[key]) return bag[key];
                }
            }
        }
        
        // Check if codes are stored in album info
        if (this.tokenData.albums) {
            for (const key of candidates) {
                const albumInfo = this.tokenData.albums[key];
                if (albumInfo) {
                    for (const prop of possibleCodeProperties) {
                        if (albumInfo[prop]) return albumInfo[prop];
                    }
                }
            }
        }
        
        // Check downloadCodeMapping with candidate keys
        const map = this.tokenData.downloadCodeMapping;
        if (map) {
            for (const key of candidates) {
                if (map[key]) return map[key];
            }
        }
        
        return null;
    }

    normalizeAlbumIdForServer(albumId) {
        try {
            if (!albumId) return albumId;
            const up = String(albumId).toUpperCase();
            const dehy = up.replace(/-/g, '');
            const m = dehy.match(/^RJ(\d)A$/);
            if (m) return `RJ-${m[1]}A`;
            return albumId;
        } catch (e) {
            return albumId;
        }
    }

    generateDownloadButtons(albumId, albumInfo) {
        const formats = ['mp3', 'flac', 'wav'];
        
        return formats.map(format => {
            const downloads = albumInfo.downloads[format] || 0;
            const isExhausted = downloads === 0;
            const canRecharge = !albumInfo.rechargeUsed && isExhausted;

            return `
                <div class="rj-download-button-wrapper">
                    <button 
                        class="rj-download-button ${isExhausted ? 'exhausted' : 'available'}"
                        data-album-id="${albumId}"
                        data-format="${format}"
                        data-recharge="${canRecharge}"
                        ${isExhausted && !canRecharge ? 'disabled' : ''}
                    >
                        <span class="rj-format-text">
                            ${isExhausted ? (canRecharge ? 'Refresh downloads' : 'No downloads left') : `Download ${format.toUpperCase()}`}
                        </span>
                    </button>
                    <div class="rj-progress-dots">
                        ${this.generateProgressDots(downloads, this.downloadLimits[format])}
                    </div>
                </div>
            `;
        }).join('');
    }

    generateProgressDots(remaining, total, format) {
        if (remaining === undefined || total === undefined) {
            return '';
        }
        
        // Handle Bandcamp format differently
        if (format === 'bandcamp') {
            return this.generateBandcampRedeemButton();
        }

        const usedCount = total - remaining;
        const iconSrc = 'https://cdn.shopify.com/s/files/1/0757/1180/7763/files/RJ-Download-W.svg?v=1757006247';

        return Array.from({ length: total }, (_, i) => {
            const isUsed = i < usedCount;
            if (isUsed) {
                // Used up download: check mark by itself
                return `<span class="rj-progress-dot-check" aria-hidden="true">✓</span>`;
            } else {
                // Remaining download: use themed download icon as a background to prevent any intrinsic stretching
                return `<span class="rj-progress-icon" style="--rj-progress-icon: url('${iconSrc}');" aria-hidden="true"></span>`;
            }
        }).join('');
    }

    generateBandcampRedeemButton() {
        return `
            <div class="rj-bandcamp-redeem-container" style="display: inline-flex; align-items: center; justify-content: center;">
                <a href="https://ronaldjenkees.bandcamp.com/yum" target="_blank" rel="noopener noreferrer" class="rj-bandcamp-redeem-button" style="
                    display: inline-flex;
                    align-items: center;
                    flex-direction: row;
                    gap: 0px;
                    padding: 12px 18px;
                    background: #5e95cb;
                    border: 1px solid rgba(94, 149, 203, 0.9);
                    border-radius: 20px;
                    color: white;
                    text-decoration: none;
                    font-size: 1.35rem;
                    font-weight: 700;
                    letter-spacing: 0.3px;
                    transition: all 0.2s ease;
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    line-height: 1.2;
                    height: auto;
                    text-align: center;
                " onmouseover="this.style.background='#6ea6d4'; this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 12px rgba(0, 0, 0, 0.2)'"
                   onmouseout="this.style.background='#5e95cb'; this.style.transform='translateY(0)'; this.style.boxShadow='none'">
                    <span>Redeem</span>
                </a>
            </div>
        `;
    }

    getAlbumSubtitle(albumId, albumName) {
        return 'Tracks for Jamming With Ronald Jenkees';
    }

    ensureFirstDownloadModalBindings() {
        if (this._firstDownloadModalBound) return;
        this._firstDownloadModalBound = true;

        const popup = document.getElementById('first-download-popup');
        if (!popup) return;
        let _firstAnimTimer = null;

        const showPopup = () => {
            // Reset any previous state on the dots (no animation)
            const steps = popup.querySelectorAll('.rj-download-steps-animation .rj-step');
            steps.forEach(s => s.classList.remove('checking', 'rj-step-checked'));

            // Show popup (no dot animation)
            popup.style.display = 'block';
            popup.setAttribute('aria-hidden', 'false');

            // Ensure any pending timers are cleared
            if (_firstAnimTimer) {
                clearTimeout(_firstAnimTimer);
                _firstAnimTimer = null;
            }
        };

        const hidePopup = () => {
            popup.style.display = 'none';
            popup.setAttribute('aria-hidden', 'true');
            if (_firstAnimTimer) {
                clearTimeout(_firstAnimTimer);
                _firstAnimTimer = null;
            }
        };

        const confirmBtn = document.getElementById('confirm-first-download');
        const cancelBtn = document.getElementById('cancel-first-download');
        const backdrop = popup.querySelector('.rj-modal-backdrop');

        if (confirmBtn) {
            confirmBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                hidePopup();
                const fn = this.pendingDownload;
                this.pendingDownload = null;
                if (typeof fn === 'function') {
                    try {
                        await fn();
                    } catch (error) {
                        console.error('Download failed:', error);
                    }
                }
            });
        }

        if (cancelBtn) {
            cancelBtn.addEventListener('click', (e) => {
                e.preventDefault();
                hidePopup();
                this.pendingDownload = null;
            });
        }

        if (backdrop) {
            backdrop.addEventListener('click', (e) => {
                e.preventDefault();
                hidePopup();
                this.pendingDownload = null;
            });
        }

        // Expose for internal use
        this._showFirstDownloadPopup = showPopup;
        this._hideFirstDownloadPopup = hidePopup;
    }


    initializeDownloadEventListeners() {
        const container = document.getElementById('rj-albumContainer');
        if (!container) return;

        container.addEventListener('click', async (event) => {
            if (event.target.closest('.rj-bandcamp-code-item, .rj-bandcamp-redeem-button, .rj-bandcamp-redeem-container')) {
                return; // Let Bandcamp elements handle their own clicks
            }

            let downloadButton = event.target.closest('.rj-download-button, .rj-crunchy-download-button, .rj-download-text');
            
            if (!downloadButton) {
                const downloadSection = event.target.closest('.rj-card-download-section');
                if (downloadSection) {
                    const activeTab = document.querySelector('.rj-format-tab.active');
                    const selectedFormat = activeTab ? activeTab.dataset.format : 'mp3';
                    if (selectedFormat === 'bandcamp') {
                        return; // Don't process Bandcamp sections as downloads
                    }
                    
                    downloadButton = downloadSection.querySelector('.rj-download-text');
                }
            }
            
            if (!downloadButton) return;

            const format = downloadButton.dataset.format;
            if (format === 'bandcamp') {
                return; // Let Bandcamp elements handle their own functionality
            }

            const isExhausted = downloadButton.classList.contains('exhausted') || (downloadButton.textContent || '').toLowerCase().includes('no downloads left');
            const canRecharge = downloadButton.dataset.recharge === 'true';
            if (isExhausted && !canRecharge) {
                this.highlightContactCTA();
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            const albumId = downloadButton.dataset.albumId;
            const isRecharge = downloadButton.dataset.recharge === 'true';

            if (!isRecharge && !this.hasCompletedAnyDownload) {
                this.pendingDownload = () => this.performDownload(albumId, format);
                if (typeof this._showFirstDownloadPopup === 'function') {
                    this._showFirstDownloadPopup();
                } else {
                    const popup = document.getElementById('first-download-popup');
                    if (popup) {
                        popup.style.display = 'block';
                        popup.setAttribute('aria-hidden', 'false');
                    }
                }
                return;
            }

            if (downloadButton.disabled) return;

            try {
                if (isRecharge) {
                    await this.handleRecharge(albumId);
                } else {
                    await this.performDownload(albumId, format);
                }
            } catch (error) {
                console.error('Download action failed:', error);
                this.showErrorMessage(`Download failed: ${error.message}`);
            }
        });

        // Listen for format changes via custom event
        document.addEventListener('vaultFormatChanged', (e) => {
            setTimeout(() => this.updateAllCrunchyDownloadButtons(), 100);
        });
    }

    async performDownload(albumId, format) {
        if (!this.token || !this.tokenData.albums[albumId]) {
            throw new Error('Download not available');
        }

        const downloadButton = document.querySelector(`[data-album-id="${albumId}"][data-format="${format}"]`);
        if (!downloadButton) return;

        // Update button state
        downloadButton.classList.add('downloading');
        downloadButton.innerHTML = '<span class="rj-format-text">Downloading...</span>';
        downloadButton.disabled = true;

        try {
            const emailParam = this.email ? `&email=${encodeURIComponent(this.email)}` : '';
            const serverAlbum = this.normalizeAlbumIdForServer(albumId);
            const downloadUrl = `https://token-download-service-688914303528.us-central1.run.app/download?token=${this.token}${emailParam}&album=${serverAlbum}&format=${format}`;
            let response = await fetch(downloadUrl);

            // Fallback to public proxy on any failure
            if (!response.ok) {
                const fallbackUrl = `https://token-download-public-688914303528.us-central1.run.app/download?token=${this.token}${emailParam}&album=${serverAlbum}&format=${format}`;
                response = await fetch(fallbackUrl);
            }
            
            if (response.ok) {
                const data = await response.json();
                console.log('Download API response JSON:', data);

                // Accept alternate keys if backend uses a different field name
                const resolvedUrl = data.downloadUrl || data.url || data.signedUrl;

                if (resolvedUrl) {
                    // 1) Try anchor click (most reliable to trigger browser download)
                    try {
                        const a = document.createElement('a');
                        a.href = resolvedUrl;
                        a.rel = 'noopener noreferrer';
                        a.download = '';
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } catch (e) {
                        console.warn('Anchor click download fallback failed:', e);
                    }

                    // 2) Also set a hidden iframe as a secondary fallback
                    try {
                        let iframe = document.getElementById('vault-download-iframe');
                        if (!iframe) {
                            iframe = document.createElement('iframe');
                            iframe.id = 'vault-download-iframe';
                            iframe.style.display = 'none';
                            iframe.width = '1';
                            iframe.height = '1';
                            iframe.setAttribute('aria-hidden', 'true');
                            document.body.appendChild(iframe);
                        }
                        iframe.src = resolvedUrl;
                    } catch (e) {
                        console.warn('Iframe download fallback failed:', e);
                    }

                    // Mark that at least one download has completed successfully
                    this.hasCompletedAnyDownload = true;
                    this.saveDownloadCompletionFlag();

                    // Update local state
                    this.tokenData.albums[albumId].downloads[format]--;

                    // Show success state
                    downloadButton.classList.remove('downloading');
                    downloadButton.classList.add('download-success');
                    downloadButton.innerHTML = '<span class="rj-format-text">✓ Downloaded</span>';

                    // Update UI after delay
                    setTimeout(() => {
                        this.updateAlbumDownloadUI(albumId);
                    }, 2000);
                } else {
                    const message = data.message || data.error || 'No download URL received from server';
                    throw new Error(message);
                }
            } else {
                // Try to parse JSON error body if available
                let errorText = '';
                try {
                    const errJson = await response.json();
                    errorText = JSON.stringify(errJson);
                } catch (_) {
                    try {
                        errorText = await response.text();
                    } catch (__) {
                        errorText = 'Unknown error';
                    }
                }

                throw new Error(`Download request failed: ${response.status} - ${errorText}`);
            }
        } catch (error) {
            console.error('Download Error:', error);
            
            // Reset button state
            downloadButton.classList.remove('downloading');
            downloadButton.disabled = false;
            this.updateAlbumDownloadUI(albumId);
            
            throw error;
        }
    }

    async handleRecharge(albumId) {
        const albumInfo = this.tokenData.albums[albumId];
        if (!albumInfo) return;

        const confirmed = await this.showRechargeConfirmation(albumId, albumInfo);
        if (!confirmed) return;

        const rechargeButton = document.querySelector(`[data-album-id="${albumId}"][data-recharge="true"]`);
        if (!rechargeButton) return;

        // Update button state
        rechargeButton.classList.add('downloading');
        rechargeButton.innerHTML = '<span class="rj-format-text">Refreshing...</span>';
        rechargeButton.disabled = true;

        try {
            const rechargeUrl = `https://token-download-service-688914303528.us-central1.run.app/recharge-album?token=${this.token}&album=${albumId}`;
            let response = await fetch(rechargeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });
            
            // Fallback to public proxy
            if (!response.ok && response.status === 403) {
                const fallbackUrl = `https://token-download-public-688914303528.us-central1.run.app/recharge-album?token=${this.token}&album=${albumId}`;
                response = await fetch(fallbackUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });
            }
            
            if (response.ok) {
                const data = await response.json();
                
                if (data.success) {
                    // Update local data
                    this.tokenData.albums[albumId].downloads = { mp3: 3, flac: 3, wav: 3 };
                    this.tokenData.albums[albumId].rechargeUsed = true;
                    
                    rechargeButton.innerHTML = '<span class="rj-format-text">Refreshed!</span>';
                    
                    setTimeout(() => {
                        this.updateAlbumDownloadUI(albumId);
                    }, 2000);
                } else {
                    throw new Error(data.message || 'Recharge failed');
                }
            } else {
                const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
                throw new Error(errorData.error || `Recharge request failed: ${response.status}`);
            }
        } catch (error) {
            console.error('Recharge Error:', error);
            
            if (error.message.includes('already used')) {
                this.showErrorMessage('Recharge has already been used for this album.');
            } else {
                this.showErrorMessage(`Recharge failed: ${error.message}`);
            }
            
            // Reset button state
            rechargeButton.classList.remove('downloading');
            rechargeButton.disabled = true;
            rechargeButton.innerHTML = '<span class="rj-format-text">No downloads left</span>';
        }
    }

    updateAllCrunchyDownloadButtons() {
        if (!this.tokenData || !this.tokenData.albums) return;

        const activeTab = document.querySelector('.rj-format-tab.active');
        const selectedFormat = activeTab ? activeTab.dataset.format : 'mp3';

        Object.keys(this.tokenData.albums).forEach(albumId => {
            const albumInfo = this.tokenData.albums[albumId];
            const albumElement = document.querySelector(`[data-album-id="${albumId}"]`);
            
            if (albumElement && albumElement.classList.contains('rj-card-style')) {
                const downloadButtonContainer = albumElement.querySelector('.rj-download-button-container');
                if (downloadButtonContainer) {
                    const fontColor = (albumInfo.styles && albumInfo.styles['Font colors']) ? (albumInfo.styles['Font colors'].startsWith('#') ? albumInfo.styles['Font colors'] : `#${albumInfo.styles['Font colors']}`) : '#ffffff';
                    const downloadButtonHtml = this.generateSingleDownloadButton(albumId, albumInfo, selectedFormat, fontColor);
                    downloadButtonContainer.innerHTML = downloadButtonHtml;
                }
                
                const progressDotsContainer = albumElement.querySelector('.rj-progress-dots-container');
                if (progressDotsContainer) {
                    const downloads = albumInfo.downloads[selectedFormat] || 0;
                    const progressDotsHtml = this.generateProgressDots(downloads, this.downloadLimits[selectedFormat], selectedFormat);
                    progressDotsContainer.innerHTML = progressDotsHtml;
                }
            } else {
                // Legacy support for older card style
                const crunchyDownload = document.querySelector(`[data-album-id="${albumId}"] .rj-crunchy-download`);
                if (crunchyDownload) {
                    const fontColor = (albumInfo.styles && albumInfo.styles['Font colors']) ? (albumInfo.styles['Font colors'].startsWith('#') ? albumInfo.styles['Font colors'] : `#${albumInfo.styles['Font colors']}`) : '#ffffff';
                    const downloadButtonHtml = this.generateSingleDownloadButton(albumId, albumInfo, selectedFormat, fontColor);
                    crunchyDownload.innerHTML = downloadButtonHtml;
                }
            }
        });
    }

    updateAlbumDownloadUI(albumId) {
        const albumElement = document.querySelector(`[data-album-id="${albumId}"]`);
        if (!albumElement) return;

        const albumInfo = this.tokenData.albums[albumId];
        if (!albumInfo) return;

        if (albumElement.classList.contains('rj-crunchy-album')) {
            const activeTab = document.querySelector('.rj-format-tab.active');
            const selectedFormat = activeTab ? activeTab.dataset.format : 'mp3';

            const downloadButtonContainer = albumElement.querySelector('.rj-download-button-container');
            if (downloadButtonContainer) {
                const fontColor = (albumInfo.styles && albumInfo.styles['Font colors']) ? (albumInfo.styles['Font colors'].startsWith('#') ? albumInfo.styles['Font colors'] : `#${albumInfo.styles['Font colors']}`) : '#ffffff';
                const downloadButtonHtml = this.generateSingleDownloadButton(albumId, albumInfo, selectedFormat, fontColor);
                downloadButtonContainer.innerHTML = downloadButtonHtml;
            }

            const progressDotsContainer = albumElement.querySelector('.rj-progress-dots-container');
            if (progressDotsContainer) {
                const downloads = albumInfo.downloads[selectedFormat] || 0;
                const progressDotsHtml = this.generateProgressDots(downloads, this.downloadLimits[selectedFormat], selectedFormat);
                progressDotsContainer.innerHTML = progressDotsHtml;
            }
        } else {
            const downloadSection = albumElement.querySelector('.rj-download-section');
            if (downloadSection) {
                downloadSection.innerHTML = this.generateDownloadButtons(albumId, albumInfo);
            }
        }
    }

    // Helper function to calculate luminance for contrast
    getLuminance(hex) {
        // Remove # if present
        hex = hex.replace('#', '');
        
        // Parse RGB values
        const r = parseInt(hex.substr(0, 2), 16) / 255;
        const g = parseInt(hex.substr(2, 2), 16) / 255;
        const b = parseInt(hex.substr(4, 2), 16) / 255;
        
        // Apply gamma correction
        const rs = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
        const gs = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
        const bs = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
        
        // Calculate luminance
        return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
    }

    // Helper function to get appropriate text color for contrast
    getContrastTextColor(color1, color2) {
        // Calculate average luminance of both colors
        const lum1 = this.getLuminance(color1);
        const lum2 = this.getLuminance(color2);
        const avgLuminance = (lum1 + lum2) / 2;
        
        // Return dark text for light backgrounds, light text for dark backgrounds
        return avgLuminance > 0.5 ? '#1a1a1a' : '#ffffff';
    }

    async showRechargeConfirmation(albumId, albumInfo) {
        return new Promise((resolve) => {
            let gradientColors;
            
            if (albumInfo.styles) {
                const gradient1 = albumInfo.styles.gradient1 || albumInfo.styles.Gradient1 || 
                                  albumInfo.styles['Gradient 1'] || albumInfo.styles['gradient 1'] || null;
                const gradient2 = albumInfo.styles.gradient2 || albumInfo.styles.Gradient2 || 
                                  albumInfo.styles['Gradient 2'] || albumInfo.styles['gradient 2'] || null;
                
                if (gradient1 && gradient2) {
                    gradientColors = [gradient1, gradient2];
                }
            }

            if (!gradientColors) {
                gradientColors = this.albumGradients[albumId] || this.albumGradients["RJCD1"];
            }

            const color1 = gradientColors[0].startsWith('#') ? gradientColors[0] : `#${gradientColors[0]}`;
            const color2 = gradientColors[1].startsWith('#') ? gradientColors[1] : `#${gradientColors[1]}`;
            const textColor = this.getContrastTextColor(color1, color2);
            const isLightText = textColor === '#ffffff';
            
            this.ensureModalStyles();
            
            const overlay = document.createElement('div');
            overlay.className = 'custom-modal-overlay';
            overlay.style.zIndex = '99999';
            
            overlay.innerHTML = `
                <div class="custom-modal" style="background: linear-gradient(135deg, ${color1}, ${color2});">
                    <div class="custom-modal-content">
                        <h3 class="custom-modal-title" style="color: ${textColor}; text-shadow: ${isLightText ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 1px 3px rgba(0, 0, 0, 0.2)'};">Refresh downloads for<br>"${albumInfo.name}"?</h3>
                        <p class="custom-modal-subtitle" style="color: ${textColor}; opacity: ${isLightText ? '0.9' : '0.8'};">(One-time use)</p>
                        <div class="custom-modal-buttons">
                            <button class="custom-modal-btn custom-modal-cancel" style="background: ${isLightText ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'}; color: ${textColor}; border: 1px solid ${isLightText ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'};">Cancel</button>
                            <button class="custom-modal-btn custom-modal-confirm" style="background: ${color2}; color: ${textColor};">REFRESH</button>
                        </div>
                    </div>
                </div>
            `;
            
            document.body.appendChild(overlay);
            
            const confirmBtn = overlay.querySelector('.custom-modal-confirm');
            const cancelBtn = overlay.querySelector('.custom-modal-cancel');
            
            const cleanup = () => {
                overlay.classList.remove('show');
                setTimeout(() => {
                    if (overlay.parentNode) {
                        overlay.parentNode.removeChild(overlay);
                    }
                }, 200);
            };
            
            confirmBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                cleanup();
                resolve(true);
            });
            
            cancelBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                cleanup();
                resolve(false);
            });
            
            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) {
                    cleanup();
                    resolve(false);
                }
            });
            
            requestAnimationFrame(() => {
                overlay.classList.add('show');
            });
        });
    }

    ensureModalStyles() {
        if (!document.getElementById('custom-modal-styles')) {
            const style = document.createElement('style');
            style.id = 'custom-modal-styles';
            style.textContent = `
                .custom-modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.6);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 99999 !important;
                    opacity: 0;
                    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                    padding: 20px;
                }
                
                .custom-modal-overlay.show {
                    opacity: 1 !important;
                }
                
                .custom-modal {
                    background: linear-gradient(135deg, #007aff, #5856d6);
                    border-radius: 20px;
                    box-shadow: 
                        0 20px 60px rgba(0, 0, 0, 0.3),
                        0 8px 32px rgba(0, 0, 0, 0.2);
                    max-width: 400px;
                    width: 100%;
                    position: relative;
                    overflow: hidden;
                    transform: scale(0.9) translateY(20px);
                    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                    z-index: 100000;
                }
                    
                    .custom-modal-overlay.show .custom-modal {
                        transform: scale(1) translateY(0);
                    }
                    
                    .custom-modal::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="modal-grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/><circle cx="10" cy="60" r="0.5" fill="white" opacity="0.1"/><circle cx="90" cy="40" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23modal-grain)"/></svg>');
                        pointer-events: none;
                    }
                    
                    .custom-modal-content {
                        padding: 32px 28px 24px;
                        position: relative;
                        z-index: 1;
                        text-align: center;
                    }
                    
                    .custom-modal-title {
                        font-size: 22px;
                        font-weight: 700;
                        margin: 0 0 12px 0;
                        color: white;
                        letter-spacing: -0.02em;
                        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
                        line-height: 1.3;
                    }
                    
                    .custom-modal-subtitle {
                        font-size: 16px;
                        font-weight: 500;
                        margin: 0 0 28px 0;
                        color: rgba(255, 255, 255, 0.9);
                        line-height: 1.4;
                        letter-spacing: 0.01em;
                    }
                    
                    .custom-modal-buttons {
                        display: flex;
                        gap: 12px;
                        justify-content: center;
                    }
                    
                    .custom-modal-btn {
                        padding: 14px 28px;
                        border: none;
                        border-radius: 50px;
                        font-size: 16px;
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                        font-family: inherit;
                        letter-spacing: 0.3px;
                        min-width: 100px;
                        position: relative;
                        overflow: hidden;
                    }
                    
                    .custom-modal-cancel {
                        background: rgba(255, 255, 255, 0.2);
                        color: white;
                        border: 1px solid rgba(255, 255, 255, 0.3);
                    }
                    
                    .custom-modal-cancel:hover {
                        background: rgba(255, 255, 255, 0.3);
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                    }
                    
                    .custom-modal-confirm {
                        box-shadow: 
                            0 4px 16px rgba(0, 0, 0, 0.15),
                            0 2px 8px rgba(0, 0, 0, 0.10);
                        font-weight: 700;
                        border: 1px solid transparent;
                    }
                    
                    .custom-modal-confirm:hover {
                        transform: translateY(-2px);
                        filter: brightness(1.05);
                        box-shadow: 
                            0 8px 24px rgba(0, 0, 0, 0.25),
                            0 4px 12px rgba(0, 0, 0, 0.15);
                    }
                    
                    @media (max-width: 480px) {
                        .custom-modal {
                            margin: 20px;
                            max-width: calc(100vw - 40px);
                        }
                        
                        .custom-modal-content {
                            padding: 24px 20px 20px;
                        }
                        
                        .custom-modal-title {
                            font-size: 20px;
                        }
                        
                        .custom-modal-subtitle {
                            font-size: 15px;
                            margin-bottom: 24px;
                        }
                        
                        .custom-modal-buttons {
                            flex-direction: column;
                            gap: 8px;
                        }
                        
                        .custom-modal-btn {
                            width: 100%;
                            padding: 16px 24px;
                        }
                    }
            `;
            document.head.appendChild(style);
        }
    }

    ensureContactHighlightStyles() {
        if (!document.getElementById('contact-highlight-styles')) {
            const style = document.createElement('style');
            style.id = 'contact-highlight-styles';
            style.textContent = `
                @keyframes rj-contact-pulse {
                    0%   { box-shadow: 0 0 0 0 rgba(255, 215, 0, 0.8); }
                    100% { box-shadow: 0 0 0 12px rgba(255, 215, 0, 0.0); }
                }
                .rj-contact-highlight {
                    outline: 2px solid #ffd700 !important;
                    border-radius: 10px;
                    animation: rj-contact-pulse 0.9s ease-in-out 0s 4;
                    transition: outline 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
                }
            `;
            document.head.appendChild(style);
        }
    }

    highlightContactCTA() {
        try {
            this.ensureContactHighlightStyles();

            const candidates = [
                document.querySelector('.rj-contact-button'),
                document.querySelector('a[href*="/pages/contact"]'),
                document.querySelector('a[href*="/contact"]'),
                document.querySelector('[onclick*="handleVaultContact"]')
            ];

            let el = null;
            for (const c of candidates) {
                if (c) { el = c; break; }
            }
            if (!el) {
                el = document.querySelector('a[href*="contact"]');
            }

            if (el) {
                el.classList.add('rj-contact-highlight');
                try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
                try { el.focus({ preventScroll: true }); } catch (_) {}
                setTimeout(() => {
                    if (el) el.classList.remove('rj-contact-highlight');
                }, 3000);
            } else {
                this.showErrorMessage('No downloads left. Please contact us and we’ll help.');
            }
        } catch (e) {
            this.showErrorMessage('No downloads left. Please contact us and we’ll help.');
        }
    }

    showErrorMessage(message) {
        if (typeof rjShowToast === 'function') {
            rjShowToast(message, 'error');
        } else {
            alert(message);
        }
    }

    generateContactURL() {
        if (!this.tokenData) {
            return '/pages/contact';
        }

        const params = new URLSearchParams();
        
        const customerName = this.tokenData.customerName ||
                           this.tokenData.customerFirstName ||
                           this.tokenData.name ||
                           this.tokenData.firstName ||
                           this.tokenData.customer_name;
                           
        if (customerName) {
            params.set('name', customerName);
        }
        
        // Prioritize 'customer' field where email is typically stored
        const email = this.tokenData.customer ||
                     this.tokenData.customerEmail ||
                     this.tokenData.email ||
                     this.tokenData.customer_email ||
                     this.tokenData.customerInfo?.email ||
                     this.tokenData.billing?.email ||
                     this.tokenData.contact?.email ||
                     this.tokenData.orderEmail ||
                     this.tokenData.order_email ||
                     this.tokenData.emailAddress ||
                     this.tokenData.email_address;
                     
        if (email) {
            params.set('email', email);
        }
        
        if (this.token) {
            params.set('subject', `Order: ${this.token}`);
        }

        return `/pages/contact?${params.toString()}`;
    }


    handleTokenError(error) {
        console.error('Token error:', error);
        const container = document.getElementById('rj-albumContainer');
        if (!container) return;

        container.innerHTML = `
            <div class="rj-token-error">
                <h3>Unable to Load Downloads</h3>
                <p>${error.message}</p>
                <p>Please check your download link or contact support.</p>
            </div>
        `;
        
        this.hideCheckoutSection();
    }
    
    hideCheckoutSection() {
        // Show modern vault content
        const customerFields = document.querySelector('#rj-channelInfoSection');
        if (customerFields) {
            customerFields.style.display = 'block';
            customerFields.classList.add('rj-vault-modern-container');
        }
        
        const checkoutSection = document.querySelector('#rj-selection-message');
        if (checkoutSection) {
            checkoutSection.style.display = 'block';
        }
        
        // Hide old checkout elements
        const oldHeader = document.querySelector('.rj-section-header-small');
        if (oldHeader) {
            oldHeader.style.display = 'none';
        }
        
        const oldSelection = document.querySelector('.rj-empty-selection-message');
        if (oldSelection) {
            oldSelection.style.display = 'none';
        }
    }
}

// Initialize vault system
function initializeVaultSystem() {
    const vaultWrapper = document.querySelector('.rj-vault-wrapper');
    const albumContainer = document.getElementById('rj-albumContainer');
    
    if (vaultWrapper && albumContainer) {
        window.vaultDownloadManager = new VaultTokenDownloadManager();
        window.vault = window.vaultDownloadManager;
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVaultSystem);
} else {
    initializeVaultSystem();
}

function handleVaultContact(event) {
    if (window.vaultDownloadManager && window.vaultDownloadManager.tokenData) {
        event.preventDefault();
        const contactUrl = window.vaultDownloadManager.generateContactURL();
        window.location.href = contactUrl;
        return false;
    }
    return true;
}
